import React from 'react';
import { usePageMaxWidth } from '../../hooks/useLayoutWidth';
import { PAGE_WIDTHS, usePageGutter } from './PageContainer';

interface HeaderContainerProps {
  className?: string;
  /** Merged last (e.g. justifyContent, gap overrides). */
  style?: React.CSSProperties;
  children: React.ReactNode;
}

/**
 * Centered, capped inner rail for the top bars (GlobalHeader / MainNavigation /
 * AdminHeader). The bar's background and border stay full-bleed (applied by the
 * outer <header>/<nav>); this rail caps + centers the logo/nav/actions row using
 * the SAME width token and gutter as PageContainer, so the header content always
 * shares the page body's left/right edges — in both full and comfortable modes,
 * at every breakpoint.
 *
 * The header is always capped at the `standard` (1200) tier even on `wide` body
 * pages: a utility bar reads best at <=1200, and `margin: 0 auto` anchors the
 * shared left edge regardless of the body's tier.
 */
export const HeaderContainer: React.FC<HeaderContainerProps> = ({ className, style, children }) => {
  const maxWidth = usePageMaxWidth(PAGE_WIDTHS.standard);
  const gutter = usePageGutter();
  return (
    <div
      className={className}
      style={{
        maxWidth,
        width: '100%',
        margin: '0 auto',
        paddingLeft: gutter,
        paddingRight: gutter,
        display: 'flex',
        alignItems: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default HeaderContainer;
